import React from 'react';
import { Link } from 'react-router-dom';
import { FileSearch, Upload, CreditCard, Download, Check, ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import './HowItWorks.css';

const stepIcons = [FileSearch, Upload, CreditCard, Download];

export default function HowItWorks({ showHeader = true, showCta = true }) {
  const { t, isRTL } = useLanguage();

  const steps = [
    {
      title: t.steps.step1Title,
      items: t.steps.step1Items,
    },
    {
      title: t.steps.step2Title,
      desc: t.steps.step2Desc,
    },
    {
      title: t.steps.step3Title,
      desc: t.steps.step3Desc,
    },
    {
      title: t.steps.step4Title,
      desc: t.steps.step4Desc,
    },
  ];

  return (
    <section className={`section how-it-works ${isRTL ? 'rtl' : ''}`} id={showHeader ? 'how-it-works' : undefined}>
      <div className="container">
        {showHeader && (
          <header className="how-it-works-intro">
            <h2>{t.steps.title}</h2>
            <span className="how-it-works-line" aria-hidden="true" />
          </header>
        )}

        <ol className="steps-row">
          {steps.map((step, i) => {
            const Icon = stepIcons[i];
            return (
              <li key={step.title} className="step-h" style={{ '--step-i': i }}>
                <div className="step-h-track" aria-hidden="true">
                  <span className="step-h-line" />
                  <div className="step-h-node">
                    <Icon size={20} strokeWidth={2.2} />
                  </div>
                </div>

                <article className="step-h-card">
                  <span className="step-h-num">{String(i + 1).padStart(2, '0')}</span>
                  <h3>{step.title}</h3>
                  {step.items ? (
                    <ul className="step-items">
                      {step.items.map((item) => (
                        <li key={item}>
                          <Check size={15} aria-hidden="true" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>{step.desc}</p>
                  )}
                </article>
              </li>
            );
          })}
        </ol>

        {showCta && (
          <div className="steps-cta">
            <Link to="/order" className="btn btn-primary">
              {t.steps.orderOnline}
              <ArrowRight size={18} aria-hidden="true" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
